module.exports = __webpack_public_path__ + "img/g-remove.a4e9a91a.svg";